import { ApplicationsEffetcs } from './applications.effects';
import { JobPositionsEffetcs } from './job-positions.effects';
import { AuthEffetcs } from '@auth/store/effects/auth.effects';
import { LmRecordsEffetcs } from './medical-licences.effects';
import { SannaEffetcs } from '@sanna/store/effects/sanna.effects';

export const EffectsArray: any[] = [
  ApplicationsEffetcs,
  JobPositionsEffetcs,
  AuthEffetcs,
  LmRecordsEffetcs,
  SannaEffetcs,
];
